import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {SiteContextService} from "../../services/site-context.service";
import {CommonsService} from "../../services/commons-service.service";

export class PackageMultiSelectListCtrl implements IController {
  packagesIds: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public isSelectAll: boolean;

  constructor(private commonsConstants, private siteContextService: SiteContextService, private commonsService: CommonsService) {
  }

  $onInit() {
    if (!this.options) {
      this.options = this.siteContextService.getSiteInfo().itemSettings;
    }
  }

  $onChanges(changes) {
    if (changes.packagesIds) {
      this.selectedKeys = [];
      _.forEach(this.packagesIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      packagesIds: isSelected ? _.concat(this.packagesIds, [option.id]) :
        _.filter(this.packagesIds, (id) => {
          return id !== option.id;
        })
    });
  }

  onReset() {
    this.onChange({packagesIds: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      const options = this._getFilteredOptions();
      this.onChange({packagesIds: options?.map(p => p.id) || []});
    }
  }

  isAllSelected() {
    const options = this._getFilteredOptions();
    this.isSelectAll = this.commonsService.checkIfArraysMatch(options?.map(p => p.id), this.packagesIds);
    return this.isSelectAll;
  }

  private _getFilteredOptions() {
    return !!this.queryString ? this.options?.filter(o => {
      return _.includes(JSON.stringify(o).toLowerCase(), this.queryString.toLowerCase())
    }) : this.options;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('packageMultiSelectList', {
    bindings: {
      packagesIds: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./package-multi-select-list.html').default,
    controller: PackageMultiSelectListCtrl
  });
